// MARK://dhk8/admin-shell/lib/queries/invoices
// Queries tipadas de facturas — F2.4 / ADR-0009. El Admin lee facturas por el
// grafo (erp-invoices), tenant del JWT (RLS). Escrituras (cancel, global) siguen REST.
import { graphql } from '../../gql/index.js'

export const AdminInvoicesQuery = graphql(`
  query AdminInvoices($limit: Int, $status: String) {
    invoices(limit: $limit, status: $status) {
      items {
        id
        tenantId
        customerId
        folio
        status
        totalCents
        paidCents
        currency
        issuedAt
        cfdiUuid
        satMotivo
        createdAt
      }
      total
      page
      limit
    }
  }
`)

// F2.5: clientes fiscales (erp-customers) — el Admin lista entidades fiscales del
// tenant del JWT por el grafo. Escrituras (create/update/delete) siguen REST.
export const AdminFiscalCustomersQuery = graphql(`
  query AdminFiscalCustomers($limit: Int, $q: String) {
    customers(limit: $limit, q: $q) {
      items {
        id
        tenantId
        legalName
        rfc
        email
        regimeCode
        usoCfdi
        type
        status
      }
      total
      page
      limit
    }
  }
`)

export const AdminInvoiceQuery = graphql(`
  query AdminInvoice($id: ID!) {
    invoice(id: $id) {
      id
      tenantId
      customerId
      folio
      status
      totalCents
      paidCents
      currency
      issuedAt
      cfdiUuid
      satMotivo
      createdAt
      lines {
        id
        invoiceId
        productId
        description
        qty
        unitCents
        totalCents
        taxRate
      }
    }
  }
`)


// ── F9.9: cancelación de la FACTURA (erp-invoices) por el grafo (tenant del JWT) ──
// El primer leg (cancela la fila + registra satMotivo) migra a la mutation; la
// cancelación del CFDI ante el SAT (fiscal-cfdi) sigue REST (zona reservada A2A).
export const AdminCancelInvoiceMutation = graphql(`
  mutation AdminCancelInvoice($id: ID!, $input: ErpCancelInvoiceInput!) {
    cancelInvoice(id: $id, input: $input) {
      id
      tenantId
      customerId
      folio
      status
      totalCents
      paidCents
      currency
      issuedAt
      cfdiUuid
      satMotivo
      createdAt
    }
  }
`)

// ── F8.x: escrituras de cliente fiscal por el grafo (erp-customers, tenant del JWT) ──
export const AdminCreateFiscalCustomerMutation = graphql(`
  mutation AdminCreateFiscalCustomer($input: ErpCustomerCreateInput!) {
    createCustomer(input: $input) {
      id
      tenantId
      legalName
      rfc
      email
      regimeCode
      usoCfdi
      type
      status
    }
  }
`)

export const AdminUpdateFiscalCustomerMutation = graphql(`
  mutation AdminUpdateFiscalCustomer($id: ID!, $input: ErpCustomerUpdateInput!) {
    updateCustomer(id: $id, input: $input) {
      id
      tenantId
      legalName
      rfc
      email
      regimeCode
      usoCfdi
      type
      status
    }
  }
`)

export const AdminDeleteFiscalCustomerMutation = graphql(`
  mutation AdminDeleteFiscalCustomer($id: ID!) {
    deleteCustomer(id: $id)
  }
`)
